<template>
  <Container type="card-full">
    <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div>
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vxe-table
      border
      :data="list">
      <vxe-table-column field="projectcode" title="项目编号"></vxe-table-column>
      <vxe-table-column field="projectname" title="项目名称"></vxe-table-column>
      <vxe-table-column field="" title="操作">
        <template slot-scope="scope">
          <el-button
            size="small"
            @click="del(scope.row)">删除
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  export default {
    name: 'clearData',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        query: {
          projectcode: '',
        },
        btnLoading: ''
      }
    },
    created () {
      this.$on('CLOSE', () => this.close())
      this.query.projectcode = ''
    },
    activated() {
      this.query.projectcode = ''
    },
    mounted () {
    },
    components: {MenuBtn, vggrid},
    methods: {
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getProjectListByCode',
          params: {projectcode: this.query.projectcode}
        })
        this.list = res
        this.loading = false
      },
      async del (row) {
        this.$confirm(`确定删除该项目？`, '提示', {
          type: 'warning'
        }).then(async () => {
          let res = await request({
            method: 'post',
            url: '/xmgl/project/clearTestProject',
            data: {projectid: row.projectid}
          })
          if (res.issuccess === 1) {
            this.getPageList()
            this.$message.success('项目信息清理成功')
          } else {
            this.$message.error('项目信息清理失败')
          }
        }).catch(() => {
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      search () {
        this.getPageList()
      }
    }
  }
</script>
<style lang="scss">

</style>
